// src/App.js

import React, { useState, useContext } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useParams } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import AwnFormContainer from './Components/AwnFormContainer';
 
import { Container, Row, Col } from 'react-bootstrap';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import AuthContext, { AuthProvider } from './Components/AuthContext';
import ProtectedRoute from './Components/ProtectedRoute';
import NavigationBar from './Components/NavigationBar';
import SideNavbarNew from './Components/SideNavbarNew';
import MappingPage from './Components/BCM_Norms/MappingPage';
import JTSide from './Components/JTSide';
import TSSideNew from './Components/TSSideNew';
import RFQPublicDiscussionPage from './Components/RFQPublicDiscussionPage';
import SurveySide from './Components/SurveySide';
import Operations from './Components/Operations';
import Awn1 from './Components/Awn1';
import SpssFileManager from './Components/SpssFileManager';
import Login from './Components/Login';
import SignUpForm from './Components/SignUpForm';
import Home from './Components/Home';
import DisplayData from './Components/DisplayData';
import FileUpload from './Components/ExcelUpload';
import CrossTab from './Components/CrossTab';
import Chatbot from './Components/Chatbot';
import Norms from './Components/Norms';
import Filters from './Components/Filters';
import SurveyDetails from './Components/SurveyDetails';
import JTProjectList from './Components/JTProjectList';
import DocumentManager from "./Components/DocumentManager";
import Conclusion from './Components/Conclusion';
import SegView from './Components/SegView';
import JTNewEntry from './Components/JTNewEntry';
import Survey from './Components/Survey';
import DriverAnalysisPage from './Components/DriverAnalysisPage';
import NormsProjectSummaryCard from './Components/NormsProjectSummaryCard';
import JTSegmentSummary from './Components/JTSegmentSummary';
import ForgotPassword from './Components/ForgotPassword';
import './App.css';
import SurveyInsights from './Components/SurveyInsights';
import DriverUserManual from './Components/DriverUsermanual';
import DriverAnalysisGuide from './Components/DriverAnalysisGuide';
import Timesheet from './Components/Timesheet';
import JTDiscussionPage from './Components/JTDiscussionPage'
import UserProfile from './Components/UserProfile';
import ImageResizer from './Components/ImageResizer';
import JTInbox from './Components/JTInobx';
import MessagesPage from './Components/MessagesPage';
import TodaySummary from './Components/TodaySummary';
import FilterSummary from './Components/TFlterSummary';
import TSProjectSummary from './Components/TSProjectSummary';
import JTResourceUnassigned from './Components/JTResourceUnassigned';
import EditResource from './Components/EditResource';
import TSTSProjectTaskStatus from './Components/TSProjectTaskStatus';
import LinkedInEmbed  from './Components/LinkedIn';
import Homepage from './Components/HomePage';
//import VendorRfqResponse from './Components/VendorRfqResponse';
// --- NEW IMPORTS FOR VENDOR AND RFQ ---
import RfqList from './Components/Rfqlist';
import VendorDashboard from './Components/VendorDashboard';
import VendorRFQDetail from './Components/VendorRFQDetail';
import VendorSide from './Components/VendorSide';
import VendorList from './Components/VendorList';
import VendorForm from './Components/VendorForm';
import VendorDetail from './Components/VendorDetail';
import RfqCreateForm from './Components/RfqCreateForm';
import RfqDetail from './Components/RfqDetail';
import VendorRfqResponse from './Components/VendorRfqResponse';
import RfqResponsesSummary from './Components/RfqResponsesSummary';
// --- END OF NEW IMPORTS ---

// <-- IMPORT THE VERIFICATION COMPONENT
// Make sure the path is correct for your project structure
import VerificationPage from './Components/VerificationPage';
import ChangeLogManager from './Components/ChangeLogManager';
import BcmNormsSide from './Components/BCM_Norms/BcmNormsSide'; // <-- IMPORT THE NEW SIDEBAR
import AdRecallTopBox from './Components/BCM_Norms/AdRecallTopBox'; 
import AdRecallAllFiles from './Components/BCM_Norms/AdRecallAllFiles';
// --- FIX 1: IMPORT THE ANALYSISPAGE COMPONENT ---
import AnalysisPage from './Components/BCM_Norms/AnalysisPage'; 
import AllSurveys from './Components/AllSurveys';
import DiscussionDashboard from './Components/DiscussionDashboard';
import DesignationProtectedRoute from './Components/DesignationProtectedRoute';
import DepartmentProtectedRoute from './Components/DepartmentProtectedRoute';
import OECodingList from './Components/OECodingList';
import OECodingForm from './Components/OECodingForm';
import OECodingDetail from './Components/OECodingDetail';
import OneDriveExcel from './Components/OneDriveExcel';
import AccountsReport from './Components/AccountsReport';
import AdminActivity from './Components/AdminActivity';
import SuperAdminUsers from './Components/SuperAdminUsers';
import ExpenseList from './Components/ExpenseList';
import ExpenseEdit from './Components/ExpenseEdit';
import ExpensePublicView from './Components/ExpensePublicView';
import ExpensePortal from './Components/ExpensePortal';
import PlatformIssuesPage from './Components/PlatformIssuesPage';
import InstallBanner from './Components/InstallBanner';
import DataQCPage from './Components/DataQCPage';
import IDCardPage from './Components/IDCardPage';

function App() {
  const [fileData, setFileData] = useState([]);

  return (
    <AuthProvider>
      <Router>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <AppContent fileData={fileData} setFileData={setFileData} />
        </LocalizationProvider>
        <InstallBanner />
      </Router>
    </AuthProvider>
  );
}

const AppContent = ({ fileData, setFileData }) => {
  const location = useLocation();


  // Sidebar paths
  const sidebarPaths = [
    '/home',
    '/display-data',
    '/upload',
    '/cross-tab',
    '/chatbot',
    '/norms',
    '/filters',
  ];

  const sideSurveyPaths = [
    '/researcher-wise',
    '/project-wise',
    '/survey_insights',
  ];

  const JTsidebarPaths = [
    '/projects_list',
    '/project_inbox',
    '/create-new',
    '/edit',
    '/project_detailed_view',
    '/project_summary',
    '/discussion',
    '/assign-resource',
    '/survey_insights',
    '/survey-list',
    '/messages',
    '/changelog',
  ];

  const TSsidebarPaths = [
    '/timesheet-home',
    '/timesheet',
    '/timesheet-today',
    '/timesheet-date',
    '/timesheet-project',
    '/timesheet-task-status',
  ];

  const vendorSidebarPaths = [
    '/vendors',
    '/rfqs',
  ];

  // --- FIX 2: UPDATE BCM NORMS SIDEBAR PATHS ARRAY ---
  const bcmNormsSidebarPaths = [
      '/bcm_norms/file-manager',
      '/bcm_norms/analyze',       // This is the correct path for the main analysis page
  ];

  const SummaryCardWrapper = () => {
    const location = useLocation();
    const { summaryData } = location.state || {};

    if (!summaryData) {
        return <div>No summary data available.</div>;
    }

    return <NormsProjectSummaryCard summaryData={summaryData} />;
  };
  
  const AdRecallTopBoxWrapper = () => {
    const { spssFileId } = useParams();
    const { token } = useContext(AuthContext); 
    return <AdRecallTopBox spssFileId={spssFileId} authToken={token} />;
  };

  // Determine which sidebar to show
  const showSidebar = sidebarPaths.some(path => location.pathname.startsWith(path));
  const showSideSurveybar = sideSurveyPaths.some(path => location.pathname.startsWith(path));
  const showJTSidebar = JTsidebarPaths.some(path => location.pathname.startsWith(path));
  const showTSSidebar = TSsidebarPaths.some(path => location.pathname.startsWith(path));
  const showVendorSidebar = vendorSidebarPaths.some(path => location.pathname.startsWith(path));
  const showBcmNormsSidebar = bcmNormsSidebarPaths.some(path => location.pathname.startsWith(path));

  const shouldShowAnySidebar = showSidebar || showSideSurveybar || showJTSidebar || showTSSidebar || showVendorSidebar || showBcmNormsSidebar;

  return (
    <>
      <NavigationBar />
      <Container fluid>
        <Row >
          <AuthContext.Consumer>
            {({ isLoggedIn }) =>
              isLoggedIn && (
                <>
                  {showSidebar && (
                    <Col sm={1} className="p-0">
                      <SideNavbarNew />
                    </Col>
                  )}
                  {showSideSurveybar && (
                    <Col sm={1} className="p-0">
                      <SurveySide />
                    </Col>
                  )}
                  {/* Always mounted for global polling/notifications; sidebar only shows on JT pages (controlled inside JTSide) */}
                  <div style={{ width: showJTSidebar ? '64px' : 0, flexShrink: 0 }} className="p-0">
                    <JTSide />
                  </div>
                  {showTSSidebar && (
                    <Col sm={1} className="p-0">
                      <TSSideNew />
                    </Col>
                  )}
                  {showVendorSidebar && (
                    <Col sm={1} className="p-0">
                      <VendorSide />
                    </Col>
                  )}
                  {showBcmNormsSidebar && (
                    <Col sm={1} className="p-0">
                        <BcmNormsSide />
                    </Col>
                  )}
                </>
              )
            }
          </AuthContext.Consumer>
          <Col sm={shouldShowAnySidebar ? 11 : 12} style={showJTSidebar && !showSidebar && !showSideSurveybar && !showTSSidebar && !showVendorSidebar && !showBcmNormsSidebar ? { flex: 1, maxWidth: 'calc(100% - 64px)' } : {}} className="p-0">
            <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Operations />} />
              <Route path="/linkedin" element={<LinkedInEmbed />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/signup" element={<SignUpForm />} />

              <Route path="/verify/:uid/:token" element={<VerificationPage />} />

              <Route path="/driver_analysis_user_manual" element={<DriverUserManual />} />
              <Route path="/driver_analysis_guide" element={<DriverAnalysisGuide />} />
              <Route path="/rfqs/public/invitation/:token" element={<VendorRfqResponse />} />
              <Route path="/rfqs/:rfqId/responses-summary" element={<ProtectedRoute><RfqResponsesSummary /></ProtectedRoute>} />
              <Route path="/thank-you" element={
                <div style={{textAlign: 'center', marginTop: '50px'}}>
                  <h1>Thank You!</h1>
                  <p>Your response has been recorded successfully.</p>
                </div>
              } />
                <Route path="/vendors/dashboard" element={<ProtectedRoute><VendorDashboard /></ProtectedRoute>} />
                  <Route path="/vendors/:vendorId"element={<ProtectedRoute><VendorRFQDetail /></ProtectedRoute>} />
              {/* Protected Routes */}
              <Route path="/awn" element={<ProtectedRoute><Awn1 /></ProtectedRoute>}/>
              <Route path="/awn-form" element={<DepartmentProtectedRoute allowedDepartments={['Research']}><AwnFormContainer /></DepartmentProtectedRoute>} />
              <Route path="/user-profile" element={<ProtectedRoute><UserProfile /></ProtectedRoute>}/>
              <Route path="/update-profile" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />
              <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
              <Route path="/display-data/:fileName" element={<ProtectedRoute><DisplayData fileData={fileData} /></ProtectedRoute>} />
              <Route path="/upload" element={<ProtectedRoute><FileUpload setFileData={setFileData} /></ProtectedRoute>} />
              <Route path="/img-resize" element={<ProtectedRoute><ImageResizer /></ProtectedRoute>} />
              <Route path="/cross-tab" element={<ProtectedRoute><CrossTab /></ProtectedRoute>} />
              <Route path="/chatbot" element={<ProtectedRoute><Chatbot /></ProtectedRoute>} />
              <Route path="/norms" element={<ProtectedRoute><Norms /></ProtectedRoute>} />
              <Route path="/filters" element={<ProtectedRoute><Filters /></ProtectedRoute>} />
              <Route path="/survey-list" element={<ProtectedRoute><AllSurveys /></ProtectedRoute>} />
              <Route path="/discussions" element={<ProtectedRoute><JTDiscussionPage /></ProtectedRoute>} />
              <Route path="/survey_details" element={<ProtectedRoute><SurveyDetails /></ProtectedRoute>} />
              <Route path="/survey_insights" element={<DesignationProtectedRoute allowedDesignations="Head of Data Operations"><SurveyInsights /></DesignationProtectedRoute>} />
              <Route path="/summary" element={<ProtectedRoute><SummaryCardWrapper /></ProtectedRoute>} />
              <Route path="/projects_list" element={<ProtectedRoute><JTProjectList /></ProtectedRoute>} />
              <Route path="/project_inbox" element={<ProtectedRoute><JTInbox /></ProtectedRoute>} />
              <Route path="/satisfactionsurvey/:surveyId" element={<Survey />} />
              <Route path="/documents_and_checklists" element={<ProtectedRoute><DocumentManager /></ProtectedRoute>} />
              <Route path="/assign-resource" element={<DesignationProtectedRoute allowedDesignations="Head of Data Operations"><JTResourceUnassigned /></DesignationProtectedRoute>} />
              <Route path="/create-new" element={<ProtectedRoute><JTNewEntry /></ProtectedRoute>} />
              <Route path="/edit" element={<ProtectedRoute><JTNewEntry /></ProtectedRoute>} />
              <Route path="/project_summary" element={<ProtectedRoute><JTSegmentSummary /></ProtectedRoute>} />
              <Route path="/discussion" element={<ProtectedRoute><JTDiscussionPage /></ProtectedRoute>} />
              <Route path="/messages" element={<ProtectedRoute><MessagesPage /></ProtectedRoute>} />
              <Route path="/edit-resource" element={<ProtectedRoute><EditResource /></ProtectedRoute>} />
              <Route path="/conclusion" element={<ProtectedRoute><Conclusion /></ProtectedRoute>} />
              <Route path="/project_detailed_view" element={<ProtectedRoute><SegView /></ProtectedRoute>} />
              <Route path="/changelog/:segmentId" element={<ProtectedRoute><ChangeLogManager /></ProtectedRoute>} />

              <Route path="/timesheet" element={<ProtectedRoute><Timesheet /></ProtectedRoute>} />
              <Route path="/timesheet-today" element={<ProtectedRoute><TodaySummary /></ProtectedRoute>} />
              <Route path="/timesheet-date" element={<ProtectedRoute><FilterSummary /></ProtectedRoute>} />
              <Route path="/timesheet-project" element={<ProtectedRoute><TSProjectSummary/></ProtectedRoute>} />
              <Route path="/timesheet-task-status" element={<ProtectedRoute><TSTSProjectTaskStatus/></ProtectedRoute>} />

              {/* --- VENDOR & RFQ ROUTES --- */}
              <Route path="/vendors/dashboard" element={<ProtectedRoute><div>Vendor Dashboard Page</div></ProtectedRoute>} />
              <Route path="/vendors" element={<ProtectedRoute><VendorList /></ProtectedRoute>} />
              <Route path="/discussion/:token" element={<RFQPublicDiscussionPage />} />
              <Route path="/vendors/new" element={<VendorForm />} />
              <Route path="/vendors/:vendorId" element={<ProtectedRoute><VendorDetail /></ProtectedRoute>} />
              <Route path="/vendors/:vendorId/edit" element={<ProtectedRoute><VendorForm /></ProtectedRoute>} />
              
              {/* --- BCM Norms Routes --- */}
              <Route path="/bcm_norms/file-manager" element={<ProtectedRoute><SpssFileManager /></ProtectedRoute>} />
              <Route path="/bcm_norms/mapping" element={<ProtectedRoute><MappingPage /></ProtectedRoute>} />
              {/* --- FIX 3: ADD THE CORRECT ROUTE AND REMOVE THE OLD ONE --- */}
              <Route 
                path="/bcm_norms/analyze" 
                element={<ProtectedRoute><AnalysisPage /></ProtectedRoute>}
              />
              <Route 
                path="/bcm_norms/ad-recall/:spssFileId" 
                element={<ProtectedRoute><AdRecallTopBoxWrapper /></ProtectedRoute>} 
              />
              {/* The following line is now redundant and can be removed, but is left for reference */}
              {/* <Route path="/bcm_norms/ad-recall-all" element={<ProtectedRoute><AdRecallAllFiles /></ProtectedRoute>} /> */}

              {/* --- Open End Coding Routes --- */}
              <Route path="/oe-coding" element={<ProtectedRoute><OECodingList /></ProtectedRoute>} />
              <Route path="/oe-coding/new" element={<ProtectedRoute><OECodingForm /></ProtectedRoute>} />
              <Route path="/oe-coding/:jobId" element={<ProtectedRoute><OECodingDetail /></ProtectedRoute>} />
              <Route path="/data-qc" element={<DepartmentProtectedRoute allowedDepartments={['Data Processing', 'Data Operations']}><DataQCPage /></DepartmentProtectedRoute>} />
              <Route path="/idcard" element={<ProtectedRoute><IDCardPage /></ProtectedRoute>} />

              {/* --- OneDrive Accounts Routes --- */}
              <Route path="/accounts" element={<ProtectedRoute><OneDriveExcel /></ProtectedRoute>} />
              <Route path="/accounts-report" element={<ProtectedRoute><AccountsReport /></ProtectedRoute>} />

              <Route path="/vendors/rfqs" element={<ProtectedRoute><RfqList/></ProtectedRoute>} />
              <Route path="/rfqs/new" element={<ProtectedRoute><RfqCreateForm /></ProtectedRoute>} />
              <Route path="/rfqs/:rfqId" element={<ProtectedRoute><RfqDetail /></ProtectedRoute>} />

              {/* Driver Analysis Path */}
              <Route
                path="/driver_analysis"
                element={<ProtectedRoute><DriverAnalysisPage /></ProtectedRoute>}
              />

              {/* Admin routes */}
              <Route path="/admin-activity" element={<ProtectedRoute><AdminActivity /></ProtectedRoute>} />
              <Route path="/superadmin/users" element={<ProtectedRoute><SuperAdminUsers /></ProtectedRoute>} />

              {/* Expense routes */}
              <Route path="/expenses" element={<ExpensePortal />} />
              <Route path="/expenses/:year/:month" element={<ExpensePortal />} />
              <Route path="/expenses/manage" element={<DesignationProtectedRoute allowedDesignations={['Head of Data Operations','Accounts','Finance']}><ExpenseList /></DesignationProtectedRoute>} />
              <Route path="/expenses/edit/:year/:month" element={<DesignationProtectedRoute allowedDesignations={['Head of Data Operations','Accounts','Finance']}><ExpenseEdit /></DesignationProtectedRoute>} />
              <Route path="/expenses/view/:token" element={<ExpensePublicView />} />

              {/* Platform Issues */}
              <Route path="/platform-issues" element={<ProtectedRoute><PlatformIssuesPage /></ProtectedRoute>} />

              {/* Redirect any undefined paths to home */}
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default App;